import {
  getComparativoCotizaciones,
} from "../../services/api";

export const COTIZACIONES_API =
  "Backend Cotizaciones / Google Sheets";

export async function getComparativo({
  signal,
} = {}) {
  /*
   * El cliente httpCotizaciones existente ya incorpora
   * autenticacion mediante el interceptor global.
   *
   * signal se conserva en la firma para compatibilidad
   * con CotizacionesV2.
   */

  return await getComparativoCotizaciones();
}